import {
  Outlet, useSearchParams, useLocation, matchPath,
} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
// import { useDispatch } from 'react-redux';
import {
  useEffect, useMemo, useState,
} from 'react';
// import useModal from 'src/hooks/useModal';
import sensorsCollectRun from '../../../common/sensors';
import antdTheme from './antdTheme';
import componentsTheme from './componentsTheme';
import 'dayjs/locale/zh-cn';
import 'src/ant-custom-css/global/index.less';

// 是否是本地环境
// const isLocal = process.env.REACT_APP_BASE_ENV === 'local';

export default function InitCommonProvider(props: any) {
  const { children } = props;
  // const dispatch = useDispatch();

  useEffect(() => {
    console.log('InitCommonProvider');
    // sensorsCollectRun('alpha-oa');
  }, []);

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: antdTheme,
        components: componentsTheme,
      }}
      wave={{ disabled: true }}
    >
      {children}
    </ConfigProvider>
  );
}
